module.exports = __webpack_public_path__ + "static/media/laurel_silver_with_background.34865439.svg";